import {CdkStepperModule} from '@angular/cdk/stepper';

import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MaskedCalendarComponent} from '@app/shared/components/masked-calendar/masked-calendar.component';
import {DynamicFormModule} from '@app/shared/modules/dynamic/dynamic-form.module';
import {EffectsModule} from '@ngrx/effects';
import {TranslateModule} from '@ngx-translate/core';
import {ConfirmationService, SharedModule} from 'primeng/api';
import {StepperComponent} from '../shared/components/stepper/stepper.component';
import {PrimeNgModule} from '../shared/modules/prime-ng/prime-ng.module';
import {ValidationService} from '../shared/services/validation.service';
import {BillingInfoComponent} from './components/billing-info/billing-info.component';
import {CheckoutFooterComponent} from './components/checkout-footer/checkout-footer.component';
import {CheckoutStepperComponent} from './components/checkout-stepper/checkout-stepper.component';
import {ClinicalInfoComponent} from './components/clinical-info/clinical-info.component';
import {ConsentInfoComponent} from './components/consent-info/consent-info.component';
import {OrderConfirmComponent} from './components/order-confirm/order-confirm.component';
import {OrderInfoComponent} from './components/order-info/order-info.component';
import {PatientInfoComponent} from './components/patient-info/patient-info.component';
import {CheckoutPageComponent} from './pages/checkout-page/checkout-page.component';
import {CheckoutEffects} from './state/checkout.effects';

@NgModule({
  exports: [CheckoutPageComponent],
  imports: [
    FormsModule,
    SharedModule,
    PrimeNgModule,
    ReactiveFormsModule,
    CdkStepperModule,
    StepperComponent,
    MaskedCalendarComponent,
    TranslateModule,
    DynamicFormModule,
    EffectsModule.forFeature([CheckoutEffects]),
    CheckoutPageComponent,
    OrderInfoComponent,
    CheckoutStepperComponent,
    CheckoutFooterComponent,
    BillingInfoComponent,
    ConsentInfoComponent,
    PatientInfoComponent,
    OrderConfirmComponent,
    ClinicalInfoComponent,
  ],
  providers: [ValidationService, ConfirmationService],
})
export class CheckoutModule {}
